"use client";
import React, { useEffect, useState, useRef } from "react";
import { TiStarFullOutline } from "react-icons/ti";
import { Link } from "react-router-dom";
import axios from "axios";

// Mentors component
export default function Mentors() {
  const [mentors, setMentors] = useState([]);
  const swiperRef = useRef(null);

  const AIRTABLE_URL = process.env.REACT_APP_AIRTABLE_URL;
  const AIRTABLE_TOKEN = process.env.REACT_APP_AIRTABLE_TOKEN;

  // Fetch alumni data
  useEffect(() => {
    async function fetchMentorData() {
      try {
        const response = await axios.get(`${AIRTABLE_URL}/mentor`, {
          headers: {
            Authorization: `Bearer ${AIRTABLE_TOKEN}`,
          },
        });
        setMentors(response.data.records);
      } catch (error) {
        console.error("Error fetching alumni data:", error);
      }
    }

    fetchMentorData();
  }, []);
  
  return (
    <div className="max-w-6xl w-full mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4 mt-6 px-2">
        {mentors?.map((mentor, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-sm hover:shadow-md overflow-hidden group transition-all duration-300 h-full flex flex-col border border-gray-100 w-full"
          >
            {/* Image Section */}
            <div className="relative overflow-hidden">
              <img
                src={mentor.fields.image[0].thumbnails.large.url}
                alt={mentor.fields.name}
                className="w-full h-[240px] object-cover transform transition-transform duration-500 group-hover:scale-105"
              />
              {/* Mentees and Rating buttons */}
              <div className="absolute top-3 right-3 flex gap-2">
                <span className="bg-[#FFF3E0] text-[#FF9900] text-sm font-semibold px-3 py-1 rounded-full">
                  {mentor.fields.mentee_count}+ mentees
                </span>
                <span className="bg-white text-[#FF9900] text-sm font-semibold px-3 py-1 rounded-full flex items-center gap-1">
                  {mentor.fields.rating}
                  <TiStarFullOutline className="text-[#FF9900]" />
                </span>
              </div>
            </div>

            {/* Mentor Info */}
            <div className="p-5 flex-grow flex flex-col">
              {/* Name and Location */}
              <div className="flex justify-between items-center mb-3">
                <p className="text-lg font-bold text-left text-[#262626]">
                  {mentor.fields.name}
                </p>
                
                <div className="flex items-center text-sm text-[#848383]">
                  <svg
                    className="w-4 h-4 mr-1 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 2C8.13 2 5 5.13 5 9c0 4.25 7 13 7 13s7-8.75 7-13c0-3.87-3.13-7-7-7z"
                    />
                    <circle cx="12" cy="9" r="2.5" />
                  </svg>
                  {mentor.fields.location}
                </div>
              </div>

              {/* Designation & Experience */}
              <div className="text-[15px] text-[#262626] mb-4 space-y-1 text-left">
                <span className="block font-semibold">{mentor.fields.designation}</span>
                <span className="block">
                  {mentor.fields.experience} years of exp. at{" "}
                  <span className="text-slate-600 font-medium">
                    {mentor.fields.organisation}
                  </span>
                </span>
              </div>

              {/* Eligibility & Role */}
              <div className="flex flex-col text-[15px] mb-4 gap-y-2">
                <div className="text-left">
                  <span className="font-semibold">Eligibility:</span>{" "}
                  {mentor.fields.eligibility.map((el, i) => (
                    <span key={i}>
                      <span className="text-slate-600">{el}</span>
                      {i !== mentor.fields.eligibility.length - 1 && (
                        <span className="text-slate-600"> | </span>
                      )}
                    </span>
                  ))}
                </div>
                <div className="text-left">
                  <span className="font-semibold">Roles:</span>{" "}
                  <span className="text-slate-600">{mentor.fields.roles}</span>
                </div>
              </div>

              {/* Bottom section */}
              <div className="mt-auto pt-2">
                <div className="border-b border-gray-200 mb-3"></div>
                <div className="flex items-center justify-between text-sm font-medium text-[#262626]">
                  <span className="bg-gray-50 px-3 py-1 rounded-md">SPA</span>
                  <span className="bg-gray-50 px-3 py-1 rounded-md">Agile</span>
                  <Link
                    to="/contact-us"
                    className="flex items-center text-primary-color hover:underline group font-semibold"
                  >
                    <span>Consult now</span>
                    <svg
                      className="ml-1 w-4 h-4 group-hover:translate-x-1 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
